import { Type } from '@sinclair/typebox';
export const TrackHealthSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    status: Type.Union([
        Type.Literal('healthy'),
        Type.Literal('unhealthy'),
        Type.Literal('unreachable'),
    ]),
    statusCode: Type.Optional(Type.Number()),
    hasSpec: Type.Boolean(),
    error: Type.Optional(Type.String()),
});
export const HealthResponseSchema = Type.Object({
    status: Type.Union([Type.Literal('ok'), Type.Literal('degraded')]),
    uptime: Type.Number(),
    database: Type.Union([Type.Literal('connected'), Type.Literal('disconnected')]),
    tracks: Type.Array(TrackHealthSchema),
});
// Cheap, process-only liveness response. Used by infra probes (kubelet, ALB)
// where fanning out to every registered track is undesirable — see
// packages/hub/src/routes/health.ts.
export const HealthLiveResponseSchema = Type.Object({
    status: Type.Literal('ok'),
    uptime: Type.Number(),
});
// HUB-110 — `GET /version`: the release the running hub was built from. Behind
// the normal hub auth (not on the public probe). `null` when the image was
// built without that value (a dev run; `version` also for an untagged commit).
export const HubVersionResponseSchema = Type.Object({
    version: Type.Union([Type.String(), Type.Null()]),
    commit: Type.Union([Type.String(), Type.Null()]),
});
//# sourceMappingURL=health.js.map